import { useMutation } from "@tanstack/react-query";
import type { ProductUploadResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type CreateProductUploadIntentInput = {
  fileName: string;
  contentType: string;
  sizeBytes: number;
  productId: string;
};

export function useCreateProductUploadIntentMutation() {
  const mutation = useMutation({
    mutationFn: (input: CreateProductUploadIntentInput) =>
      apiJsonClient<ProductUploadResponse>(endpoints.seller.productUploads, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
